// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"d753eff9","216":"1f313989","259":"bf68c56a","362":"9a0913c9","416":"4a4b0bee","630":"e2e5eac6","645":"236049e0","758":"ec050ddb","766":"b153cad1","822":"e6e1b013","872":"71303b31"}[chunkId] + ".chunk.js";
};